import {extendsAPIServices} from "./APIServices"
import getEnv from "../../helpers/common/getEnv"
import {POST, GET} from "../../constants/HTTPConstants"

const baseAdminAPI = getEnv('basePaymentAPI')
const api = extendsAPIServices(baseAdminAPI)

export const _directCheckout = ({userId, price, planId, finish}) => {
    return api.makeAuthRequest({
        method: POST,
        url: '/direct/checkout',
        data: {
            userId,
            planId,
            price,
            finish
        }
    })
}

export const _getListPlans = () => {
    return api.makeAuthRequest({
        method: GET,
        url: '/plans'
    })
}



// WEBPACK FOOTER //
// ./src/services/apis/PaymentServices.js